const mapKeys = require('lodash/mapKeys');
const camelCase = require('lodash/camelCase');
const snakeCase = require('lodash/snakeCase');
const isArray = require('lodash/isArray');
const map = require('lodash/map');
const isPlainObject = require('lodash/isPlainObject');
const mapValues = require('lodash/mapValues');

function deep(obj, mapper) {
  const deeplyMap = something => deep(something, mapper);

  if (isArray(obj)) {
    return map(obj, deeplyMap);
  }
  if (isPlainObject(obj)) {
    return mapper(mapValues(obj, deeplyMap));
  }

  return obj;
}

const CaseConversionService = {
  convertObjectPropertiesToCamel: function(obj) {
    return deep(obj, it => mapKeys(it, (v, k) => camelCase(k)));
  },

  convertObjectPropertiesToSnake: function(obj) {
    return deep(obj, it => mapKeys(it, (v, k) => snakeCase(k)));
  }
};

CaseConversionService.$inject = [];

module.exports = CaseConversionService;
